import { useQuery } from "react-query";
import LoadingApiClient from "api/LoadingApiClient";

export function useFederationLoading(federationId, payload, options) {
    return useQuery(
        ["loading", "federation", Number(federationId), payload],
        () => LoadingApiClient.getFederationLoading(federationId, payload),
        options,
    );
}
